import { Model } from '@vuex-orm/core'

export default class LtmHasRoomtype extends Model{
  static entity = 'ltmHasRoomtypes'
  static fields () {
    return {
      ltms_id: this.number(null),
      roomtypes_id: this.number(null),
    }
  }
}
  